import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import './brand-table.css';
import api from '../../seller-apis/api';
import { useHistory, NavLink } from 'react-router-dom';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';

const ACTIVE = "ACTIVE";
const EXPIRED = "EXPIRED";
const PENDING = "PENDING";
const REJECTED = "REJECTED";

function getStatus(status) {
    switch (status) {
        case ACTIVE:
            return <span className='approved'>{ACTIVE}</span>
        case EXPIRED:
            return <span className='rejected'>{EXPIRED}</span>
        case REJECTED:
            return <span className='rejected'>{REJECTED}</span>
        default:
            return <span className='pending'>{PENDING}</span>
    }
}

function BrandTable(props) {
    const [modal, setModal] = useState(false);
    const [shareModal, setShareModal] = useState(false);
    const [subscriptionDetails, setSubscriptionDetails] = useState();
    const [selectedBrand, setSelectedBrand] = useState(null);
    const [isCopied, setIsCopied] = useState(false);
    const history = useHistory();

    const handleModal = async (row) => {
        setModal(!modal);
        setSubscriptionDetails(row);
    };

    const handleShareModal = async (row) => {
        setSelectedBrand(row);
        setShareModal(true);
        setIsCopied(false); // Reset copy state when opening modal
    };

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            setIsCopied(true);
            // Reset to "Copy" after 2 seconds
            setTimeout(() => {
                setIsCopied(false);
            }, 2000);
        } catch (error) {
            console.error('Failed to copy text: ', error);
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
                setIsCopied(true);
                setTimeout(() => {
                    setIsCopied(false);
                }, 2000);
            } catch (fallbackError) {
                console.error('Fallback copy failed: ', fallbackError);
            }
            document.body.removeChild(textArea);
        }
    };

  // Share on WhatsApp function
  const shareOnWhatsApp = (brand, url) => {
    const message = `Checkout *${brand?.brandName || brand?.manufacturerName}* Brandstore on Toolsvilla: \n🛒 Explore now: ${url}`;
    //const whatsappUrl = `https://api.whatsapp.com/send/?text=${encodeURI(message)}`;
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

    const {
        headers,
        rows
    } = props;

    const imageUrl = (images) => {
        let imageUrlDomain = "", imageUrl = 'https://s3.toolsvilla.com/';
        imageUrlDomain = images.find((item) => !item.image.includes('toolsvilla'))

        if (imageUrlDomain) {
            return imageUrl + imageUrlDomain.image;
        }
        imageUrlDomain = images.find((item) => item.image.includes('toolsvilla'))
        if (imageUrlDomain) {
            return imageUrlDomain.image;
        }
        return null;
    };

    const styles = {
        modalBody: {
            backgroundColor: '#f8fafc'
        },
        container: {
            maxWidth: '500px',
            margin: '0 auto'
        },
        header: {
            textAlign: 'center',
            marginBottom: '1.5rem',
            color: '#1e293b',
            fontWeight: '600',
            fontSize: '1.25rem'
        },
        card: {
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '1.25rem',
            marginBottom: '1.5rem',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
            border: '1px solid #e2e8f0'
        },
        cardIcon: {
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            backgroundColor: '#f0f9ff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '1rem',
            flexShrink: 0
        },
        iconPrimary: {
            fontSize: '1.25rem',
            color: 'var(--primary)'
        },
        cardContent: {
            flex: 1
        },
        cardLabel: {
            margin: 0,
            color: '#64748b',
            fontSize: '0.875rem',
            fontWeight: '500'
        },
        cardValue: {
            margin: '0.25rem 0 0',
            color: 'var(--primary)',
            fontWeight: '600'
        },
        timelineContainer: {
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '1.5rem',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
            border: '1px solid #e2e8f0'
        },
        timeline: {
            position: 'relative',
            paddingLeft: '1.5rem'
        },
        timelineLine: {
            position: 'absolute',
            left: '28px',
            top: '20px',
            bottom: '39px',
            width: '2px',
            backgroundColor: '#e2e8f0'
        },
        timelineItem: {
            display: 'flex',
            position: 'relative',
            marginBottom: '1.5rem',
            alignItems: 'flex-start'
        },
        timelineDotStart: {
            width: '20px',
            height: '20px',
            borderRadius: '50%',
            backgroundColor: '#22c55e',
            border: '4px solid #dcfce7',
            flexShrink: 0,
            marginRight: '1rem',
            position: 'relative',
            zIndex: 1
        },
        timelineDotEnd: {
            width: '20px',
            height: '20px',
            borderRadius: '50%',
            backgroundColor: '#ef4444',
            border: '4px solid #fee2e2',
            flexShrink: 0,
            marginRight: '1rem',
            position: 'relative',
            zIndex: 1
        },
        timelineContent: {
            flex: 1
        },
        timelineLabel: {
            margin: '0 0 0.25rem',
            color: '#64748b',
            fontSize: '0.875rem',
            fontWeight: '500'
        },
        timelineDate: {
            margin: 0,
            color: 'var(--primary)',
            fontWeight: '600'
        },
        timelineDuration: {
            display: 'flex',
            alignItems: 'center',
            margin: '0.5rem 0 1.5rem 2rem',
            color: '#64748b',
            fontSize: '0.875rem'
        },
        arrowIcon: {
            marginRight: '0.5rem',
            color: '#94a3b8'
        },
        durationText: {
            fontWeight: '500'
        },
        // Share modal styles
        shareModalBody: {
            backgroundColor: 'white',
            padding: '1.0rem'
        },
        shareContainer: {
            maxWidth: '400px',
            margin: '0 auto'
        },
        shareHeader: {
            textAlign: 'left',
            marginBottom: '0.5rem',
            color: '#333',
            fontWeight: '600',
            fontSize: '0.875rem'
        },
        urlContainer: {
            backgroundColor: '#f8f9fa',
            borderRadius: '4px',
            padding: '0.75rem',
            marginBottom: '1rem',
            border: '1px solid #dee2e6',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        },
        urlText: {
            flex: 1,
            fontSize: '0.875rem',
            color: '#495057',
            wordBreak: 'break-all',
            fontFamily: 'monospace'
        },
        copyButton: {
            backgroundColor: isCopied ? '#28a745' : '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '0.375rem 0.75rem',
            fontSize: '0.875rem',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem',
            fontWeight: '500',
            transition: 'background-color 0.3s ease'
        },
        whatsappSection: {
            marginBottom: '1rem'
        },
        whatsappButton: {
            backgroundColor: '#25d366',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '0.75rem 1rem',
            fontSize: '0.875rem',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            width: '100%',
            fontWeight: '500'
        },
        closeButton: {
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '0.5rem 1rem',
            fontSize: '0.875rem',
            cursor: 'pointer',
            width: '100%',
            marginTop: '0.5rem'
        }
    };

    return (
        <div className='mt-5'>
            <table className='brand-table'>
                <thead className='brand-table-thead'>
                    <tr className='thead-row'>
                        {
                            headers.map(
                                (header) =>
                                    <th key={header.key} className='thead-col'>
                                        {header.label}
                                        {/* Add share option in header for Brand Store column */}
                                        {header.key === 'brand_store' && (
                                            <span className='ms-2'>
                                                <i className="bi bi-share" style={{ fontSize: '0.875rem', color: '#6b7280' }}></i>
                                            </span>
                                        )}
                                    </th>
                            )
                        }
                    </tr>
                </thead>
                <tbody className='brand-table-tbody'>
                    {
                        rows.map((row) => {
                            if (row === null) return null;
                            // Calculate days left till subscription expiry when status is SUBSCRIBED
                            let daysLeft = 0;
                            if(row?.subscription_status === "SUBSCRIBED"){
                                const expiryDate = new Date(row?.subscription_expiry);
                                const today = new Date();
                                const timeDiff = expiryDate - today;
                                daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
                            }
                            
                            return (
                                <tr key={row._id} className='brand-table-tbody-row'>
                                    <td className='brand-table-tbody-col'>
                                        {new Date(row?.created_at).toLocaleDateString()}
                                    </td>
                                    <td className='brand-table-tbody-col'>
                                        {
                                            (row?.status === "ACTIVE" && row?.subscription_status === "SUBSCRIBED") ? row?.brandName ? row.brandName : row?.manufacturerName :
                                                row?.brandName ? row.brandName : row?.manufacturerName
                                        }
                                    </td>
                                    <td className='brand-table-tbody-col'>
                                        {getStatus(row?.status)}
                                        {
                                            row.status === 'REJECTED' ?
                                                <OverlayTrigger
                                                    overlay={<Tooltip>{row?.reason}</Tooltip>}>
                                                    <i className="fa fa-info ms-2 text-danger cursor-pointer" />
                                                </OverlayTrigger>
                                                : null
                                        }
                                    </td>
                                    {/* <Start-Here> Brand Expiry Ticket : SL-811 */}
                                    <td className='brand-table-tbody-col'>
                                        {row?.subscription_status === "SUBSCRIBED" ? <>
                                            <span className='approved'>{row?.subscription_status}
                                                <span className='ms-2 brand-tb-subs-dets' onClick={() => handleModal(row)}><i className="bi bi-eye" style={{ cursor: 'pointer' }} ></i></span>
                                            </span> 
                                            {/* notifiedBeforeExpiry is set true from backend cron which will check for expiry  */}
                                            {(row?.notifiedBeforeExpiry || (daysLeft >= 0 && daysLeft <= 7) ) &&
                                                        <div style={{ marginTop:"-10px"}}>
                                                            <span className='rejected' style={{ cursor: 'pointer' }}
                                                                onClick={() => history.push('/apply-brand/2/' + row?._id)}>
                                                            Expiring Soon <Badge bg="primary" className='ms-1'
                                                            style={{ cursor: 'pointer' }}
                                                            >Pay Now</Badge></span> 
                                                       </div> 
                                            }
                                            </>: row?.status === "ACTIVE" ?
                                            <span style={{ textDecoration: 'underline', cursor: 'pointer' }}
                                                onClick={() => history.push('/apply-brand/2/' + row?._id)}>
                                                NOT SUBSCRIBED <Badge bg="primary" className='ms-1'
                                                    style={{ cursor: 'pointer' }}
                                                >Pay Now</Badge></span> :
                                            row?.status === "PENDING" ?
                                                <span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => history.push('/apply-brand/1/' + row?._id)}>
                                                    NOT SUBSCRIBED
                                                    <Badge bg="danger" className='ms-1' style={{ cursor: 'pointer' }}
                                                    >Action Required
                                                    </Badge></span> : row?.subscription_status === "EXPIRED" ? <> <span className='rejected' style={{ cursor: 'pointer' }}
                                                        onClick={() => history.push('/apply-brand/2/' + row?._id)}>
                                                        EXPIRED <Badge bg="primary" className='ms-1'
                                                            style={{ cursor: 'pointer' }}
                                                        >Pay Now</Badge></span> </> : <><span className='approved'>{row?.subscription_status}
                                                            <span className='ms-2 brand-tb-subs-dets' onClick={() => handleModal(row)}><i className="bi bi-eye" style={{ cursor: 'pointer' }} ></i></span>
                                                        </span> </>}
                                    </td>
                                    {/* </End-Here> Brand Expiry Ticket : SL-811 */}
                                    <td className='brand-table-tbody-col'>
                                        {(row?.status === "ACTIVE" && row?.subscription_status === "SUBSCRIBED") ? (
                                            <div style={{ display: 'flex', flexDirection: 'row', gap: '0.5rem',
                                                        alignItems: 'center', justifyContent: 'center' }}>
                                                {/* <a href={row?.url} target="_blank" rel="noopener noreferrer">Click Here</a> */}
                                                <div
                                                        style={{
                                                            border: '1px solid #28a745',    // Outer border
                                                            padding: '2px',                  // Gap between outer line and button
                                                            borderRadius: '4px',            // Optional: Rounded border
                                                            display: 'inline-block'         // Ensures it only wraps the button
                                                        }}
                                                        >
                                                        <button
                                                            onClick={() => handleShareModal(row)}
                                                            style={{
                                                            backgroundColor: '#28a745',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '4px',
                                                            padding: '0.275rem 0.50rem',
                                                            fontSize: '0.600rem',
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '0.15rem',
                                                            width: 'fit-content',
                                                            fontWeight: '600'
                                                            }}
                                                            className="btn btn-success btn-sm"
                                                        >
                                                            <i className="bi bi-share"></i>
                                                            Share Store
                                                        </button>
                                                        </div>
                                            </div>
                                        ) : 'N/A'}
                                    </td>
                                </tr>
                            );
                        })
                    }
                </tbody>
            </table>

            {/* Subscription Details Modal */}
            <Modal show={modal} onHide={handleModal} size="xl" className='brand-sub-det-modal'>
                <Modal.Header className='border-bottom-0 justify-content-center'>
                    <Modal.Title className='product-modal-heading py-4'>Subscription Details</Modal.Title>
                    <img src='/brand/cross.png' className='position-absolute cursor-pointer' alt="close" height={15} style={{ right: "4%", top: "4%" }} onClick={() => setModal(false)} />
                </Modal.Header>
                <Modal.Body style={styles.modalBody}>
                    <div style={styles.container}>
                        {/* Amount Card */}
                        <div style={styles.card}>
                            <div style={styles.cardIcon}>
                                <i className="bi bi-credit-card" style={styles.iconPrimary}></i>
                            </div>
                            <div style={styles.cardContent}>
                                <p style={styles.cardLabel}>Subscription Amount</p>
                                <h4 style={styles.cardValue}>
                                    <i className="bi bi-currency-rupee"></i>{subscriptionDetails?.subscription_amount || 'N/A'}
                                </h4>
                            </div>
                        </div>

                        {/* Duration Card */}
                        <div style={styles.card}>
                            <div style={styles.cardIcon}>
                                <i className="bi bi-calendar" style={styles.iconPrimary}></i>
                            </div>
                            <div style={styles.cardContent}>
                                <p style={styles.cardLabel}>Subscription Duration</p>
                                <h4 style={styles.cardValue}>
                                    {subscriptionDetails?.subscription_plan_duration || 'N/A'} months
                                </h4>
                            </div>
                        </div>

                        {/* Timeline */}
                        <div style={styles.timelineContainer}>
                            <div style={styles.timeline}>
                                {/* Timeline line */}
                                <div style={styles.timelineLine}></div>

                                {/* Start Date */}
                                <div style={styles.timelineItem}>
                                    <div style={styles.timelineDotStart}></div>
                                    <div style={styles.timelineContent}>
                                        <p style={styles.timelineLabel}>Start Date</p>
                                        <p style={styles.timelineDate}>
                                            {subscriptionDetails?.subscription_date ?
                                                new Date(subscriptionDetails.subscription_date).toLocaleDateString('en-US', {
                                                    year: 'numeric',
                                                    month: 'short',
                                                    day: 'numeric'
                                                }) : 'N/A'}
                                        </p>
                                    </div>
                                </div>

                                {/* Expiry Date */}
                                <div style={styles.timelineItem}>
                                    <div style={styles.timelineDotEnd}></div>
                                    <div style={styles.timelineContent}>
                                        <p style={styles.timelineLabel}>Expiry Date</p>
                                        <p style={styles.timelineDate}>
                                            {subscriptionDetails?.subscription_expiry ?
                                                new Date(subscriptionDetails.subscription_expiry).toLocaleDateString('en-US', {
                                                    year: 'numeric',
                                                    month: 'short',
                                                    day: 'numeric'
                                                }) : 'N/A'}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Share Modal */}
            <Modal show={shareModal} onHide={() => setShareModal(false)} size="md" className='brand-share-modal'>
                <Modal.Header className='border-bottom-0 justify-content-center' style={{ position: 'relative', paddingBottom: '0.5rem' }}>
                    <Modal.Title style={{ fontSize: '1.125rem', fontWeight: '600', color: '#333' }}>
                        Share {selectedBrand?.brandName || selectedBrand?.manufacturerName || 'Brand'} Store
                    </Modal.Title>
                    <button 
                        onClick={() => setShareModal(false)}
                        style={{
                            position: 'absolute',
                            right: '1rem',
                            top: '1rem',
                            background: 'none',
                            border: 'none',
                            fontSize: '1.5rem',
                            cursor: 'pointer',
                            color: '#6c757d',
                            padding: '0',
                            lineHeight: '1'
                        }}
                    >
                        ×
                    </button>
                </Modal.Header>
                <Modal.Body style={styles.shareModalBody}>
                    <div style={styles.shareContainer}>
                                                
                                                            
                        <div style={styles.whatsappSection}>
                            <h6 style={styles.shareHeader}>Brand Store URL</h6>
                            <div style={{ display: 'flex', alignItems: 'stretch', gap: '0.5rem' }}>
                                <div style={{
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '4px',
                                    padding: '0.5rem',
                                    border: '1px solid #dee2e6',
                                    display: 'flex',
                                    alignItems: 'center',
                                    flex: 1,
                                    minHeight: '38px' // Match button height
                                }}>
                                    <span style={{
                                        fontSize: '0.875rem',
                                        color: '#495057',
                                        wordBreak: 'break-all',
                                        fontFamily: 'monospace'
                                    }}>
                                        {selectedBrand?.url}
                                    </span>
                                </div>
                                <button
                                    style={{
                                        backgroundColor: '#007bff',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        padding: '0.375rem 0.75rem',
                                        fontSize: '0.875rem',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '0.25rem',
                                        fontWeight: '500',
                                        minWidth: '70px',
                                        justifyContent: 'center',
                                        height: '38px' // Fixed height to match URL container
                                    }}
                                    onClick={() => copyToClipboard(selectedBrand?.url)}
                                >
                                    <i className={isCopied ? "bi bi-check" : "bi bi-files"}></i>
                                    {isCopied ? 'Copied' : 'Copy'}
                                </button>
                            </div>
                        </div>

                        <div style={styles.whatsappSection}>
                            <h6 style={styles.shareHeader}>Share on WhatsApp</h6>
                            <button
                                style={styles.whatsappButton}
                                onClick={() => shareOnWhatsApp(selectedBrand, selectedBrand?.url)}
                            >
                                <i className="bi bi-whatsapp"></i>
                                Share on WhatsApp
                            </button>
                            <p style={{ fontSize: '0.75rem', color: '#6c757d', margin: '0.5rem 0 0', textAlign: 'center' }}>
                                Opens WhatsApp with your brand store link ready to share
                            </p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default BrandTable;